// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".placeholder-card {\n    height: 132px;\n    position: relative;\n    overflow: hidden;\n    border-style: none;\n    margin: 4px;\n    border-width: 1px;\n    border-color: rgba(18, 18, 32, .07);\n    border-radius: 2px;\n    box-shadow: 0 0 0 1px #e4e4e4;\n    cursor: default;\n    text-align: center;\n    vertical-align: middle;\n}", ""]);
// Exports
module.exports = exports;
